import {BaseService} from '../baseService.js';

/* 
 * Handles Undo Management
 */
export class UndoService extends BaseService {

	constructor() {	
		super();
	}
	
	async getUndoRecords(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/undo-records' + params);		
		return data;		
	}	
	
	async getUndoRecord(undoId) {
		var data = await this.makeGETRequest('/api/resource/undo-records/' + undoId);		
		return data;		
	}	
	
	async getUndoEntity(undoId) {
		var data = await this.makeGETRequest('/api/resource/undo-records/' + undoId + '/entity');				
		return data;		
	}

	async getAffectedUnits(undoId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/undo-records/' + undoId + '/affected-units' + params);
		return data;
	}	
	
	async undoEntity(undoId) {
		var data = await this.makePUTRequest('/api/resource/undo-records/' + undoId);				
		return data;		
	}

	async restoreDeletedData(undoId, request) {
		var data = await this.makePOSTRequest('/api/resource/undo-records/' + undoId + '/restore', request || {});
		return data;
	}

	async bulkUndo(undoIds) {
		var data = await this.makePOSTRequest('/api/resource/undo-records/bulk-undo', { ids: undoIds });
		return data;
	}

	async bulkDelete(undoIds) {
		var data = await this.makePOSTRequest('/api/resource/undo-records/bulk-delete', { ids: undoIds });
		return data;
	}
	
	async deleteUndoRecord(undoId) {
		var data = await this.makeDELETERequest('/api/resource/undo-records/' + undoId);		
		return data;		
	}	
	
};
